
export default {
  inject: ['main', 'tips'],
  props: {
    urltype: {
      // 跳转类型webUrl--在线开户；sites---官网网址
      type: String,
      default: 'webUrl'
    },
    tipstype: {
      type: String,
      default: ''
    },
    ourl: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      show: false
    }
  },
  mounted() {
    this.setele()
  },
  methods: {
    setele() {
      const ele = document.querySelectorAll('#tipscontent p')
      for (let i = 0; i < ele.length; i++) {
        if (ele[i].querySelector('span')) {
          ele[i].querySelector('span').innerHTML = `<i style="display: inline-block">${i + 1}.</i>&nbsp;` + ele[i].querySelector('span').textContent
        } else {
          ele[i].style.display = 'none'
        }
      }
    },
    open() {
      this.show = true
      // this.$nextTick(() => {
      //   this.setele()
      // })
    },
    close() {
      console.log(this.tipstype, 22, this.urltype)
      // if (this.tipstype == '1') {
      //   if (this.urltype == 'webUrl') {
      //     const st = (this.main && this.main.main) ? this.main.main.webUrl : this.url
      //     const u = st.includes('http') ? st : `https://${st}`
      //     window.open(u)
      //   } else if (this.urltype == 'sites') {
      //     const u = this.ourl.includes('http') ? this.ourl : `https://${this.ourl}`
      //     window.open(u)
      //   }
      // } else {
      //   this.$emit('iframeif', true)
      // }
      this.$emit('iframeif', this.tipstype)
      this.show = false
      this.$emit('close')
    }
  }
}
